import Vue from 'vue'
import Router from 'vue-router'
import { HEADER_ACTIVE, MENU_ACTIVE } from '../constant'



const routes = [
    // { path: '/', component: () => import('../page/HomePage'), name: 'HomePage', meta: { header: HEADER_ACTIVE.DATA_SELECT, menu: MENU_ACTIVE.DATA_MODELING } },
    // 首页 - 数据全景
    { path: '/', component: () => import('../page/view/DataIndex'), name: 'HomePage', meta: { header: HEADER_ACTIVE.INDEX, menu: MENU_ACTIVE.DATA_INDEX } },
    // { path: '/er', component: () => import('../component/view/ERDiagram'), name: 'ERDiagram', meta: { header: HEADER_ACTIVE.INDEX, menu: MENU_ACTIVE.DATA_INDEX } },
    { path: '/login', component: () => import('../page/user/Login'), name: 'login2', meta: { header: '', menu: ''} },
    //关于平台
    { path: '/about_platform', component: () => import('../page/view/AboutPlatform'), name: 'AboutPlatform', meta: { header: HEADER_ACTIVE.ABOUT_PLATFORM, menu: MENU_ACTIVE.DATA_INDEX} },
    // { path: '/', component: () => import('../page/user/Login2'), name: 'login', meta: { header: '', menu: ''} },
    { path: '/register', component: () => import('../page/user/register'), name: 'register', meta: { header: '', menu: ''} },
    { path: '/forget', component: () => import('../page/user/forget'), name: 'forget', meta: { header: '', menu: ''} },
    //设置-我的信息
    { path: '/myInformation', component: () => import('../page/user/MyInformation'), name: 'MyInformation', meta: { header: HEADER_ACTIVE.MY_INFORMATION, menu: MENU_ACTIVE.MY_INFORMATION} },
    //设置-修改密码
    { path: '/changePassword', component: () => import('../page/user/ChangePassword'), name: 'changePassword', meta: { header: HEADER_ACTIVE.MY_INFORMATION, menu: MENU_ACTIVE.Change_Password} },

    { path: '/data_model', component: () => import('../page/DataModel.vue'), name: 'DataModel', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.DATA_MODELING } },
    { path: '/flow', component: () => import('../component/flow/Flow.vue'), name: 'Flow', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.DATA_MODELING } },
    { path: '/data_model_edit', component: () => import('../page/DataModelEdit.vue'), name: 'DataModelEdit', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.DATA_MODELING_DESIGN } },
    { path: '/data_import/:id?', component: () => import('../page/DataImport.vue'), name: 'DataImport', meta: { header: HEADER_ACTIVE.DATA_WORK, menu: MENU_ACTIVE.DATA_IMPORT_LIST } },
    { path: '/data_imports/:id?', component: () => import('../page/DataImports.vue'), name: 'DataImports', meta: { header: HEADER_ACTIVE.DATA_WORK, menu: MENU_ACTIVE.DATA_IMPORT_LIST } },

    { path: '/data_import_List', component: () => import('../page/DataImportList.vue'), name: 'DataImportList', meta: { header: HEADER_ACTIVE.DATA_WORK, menu: MENU_ACTIVE.DATA_IMPORT_LIST } },

    { path: '/data_import_detail', component: () => import('../page/DataImportDetail.vue'), name: 'DataImportDetail', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.DATA_IMPORT_LIST } },
    { path: '/mysql', component: () => import('../page/MysqlEditor.vue'), name: 'Mysql', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.DATA_IMPORT } },
    { path: '/python', component: () => import('../page/PythonEditor.vue'), name: 'Python', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.DATA_IMPORT } },
    // { path: '/data_stat', component: () => import('../page/DataStat.vue'), name: 'DataStat', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.DATA_STAT } },
    //数据加工-->基础数据维护
    {
        path: '/data_maintain',
        component: () => import('../page/DataMaintain.vue'),
        name: 'DataMaintain',
        meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.DATA_MAINTAIN },
        children: [
            {
                path: '/',
                component: () => import('../page/PaperList.vue'),
                name: "PaperList",
                meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.DATA_MAINTAIN },
            },
            {
                path: 'python',
                component: () => import('../page/PythonEditor.vue'),
                name: "PythonEditor",
                meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.DATA_MAINTAIN },
            },
            // {
            //     path: 'sql',
            //     component: () => import('../page/MysqlEditor.vue'),
            //     name: "MysqlEditor",
            //     meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.DATA_MAINTAIN },
            // }
            {
                path: 'sql',
                component: () => import('../page/MysqlEditorCopy.vue'),
                name: "MysqlEditor",
                meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.DATA_MAINTAIN },
            }
        ]

    },
    //数据加工-->加工数据计算
    { path: '/data_calculate', component: () => import('../page/DataCalculate.vue'), name: 'DataCalculate', meta: { header: HEADER_ACTIVE.DATA_WORK, menu: MENU_ACTIVE.DATA_CALCULATE } },
    //数据加工-->任务分发
    {path: '/task_distribute', component: () => import('../page/TaskDistribute.vue'), name: 'TaskDistribute', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Task_Distribute }},
    //任务分发-->新增任务
    {path: '/task_distribute/add', component: () => import('../page/TaskDistributeAdd.vue'), name: 'TaskDistributeAdd', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Task_Distribute }},
    {path: '/task_distribute/update', component: () => import('../page/TaskDistributeAdd.vue'), name: 'TaskDistributeAdd', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Task_Distribute }},
    //数据加工-->任务认领
    {path: '/task_claim', component: () => import('../page/TaskClaim.vue'), name: 'TaskClaim', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Task_Claim }},
    //数据加工-->任务数据加工
    {path: '/task_process', component: () => import('../page/TaskProcess.vue'), name: 'TaskProcess', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Task_Claim }},
    //任务认领-->总任务查看
    {path: '/task_claim/showTotal', component: () => import('../page/TaskClainShowTotal.vue'), name: 'TaskClainShowTotal', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Task_Claim }},
    //数据加工-->数据审核
    {path: '/task_data_verify', component: () => import('../page/TaskDataVerify.vue'), name: 'TaskDataVerify', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Data_Verify }},
    //数据加工--> 任务数据审核 - 单条
    {path: '/task_process_verify', component: () => import('../page/TaskProcessVerify.vue'), name: 'TaskProcessVerify', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Data_Verify }},
    //数据使用
    {path: '/data_mall', component: () => import('../page/DataMalls.vue'), name: 'DataMall', meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_product }},
    //{path: '/data_malls', component: () => import('../page/DataMalls.vue'), name: 'DataMalls', meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_product }},
     //数据使用-->资产详情页
    {path: '/data_mall/showDetails', component: () => import('../page/DataMallDetails.vue'), name: 'DataMallDetails', meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_product }},
    //数据使用-->数据统计
    { path: '/data_statistics',
        component: () => import('../page/DataStat.vue'),
        name: 'DataStat',
        meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_statistics },
        children: [
            {
                path: '/data_statistics/python',
                component: () => import('../page/PythonEditor.vue'),
                name: "PythonEditorStat",
                meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_statistics },
            },
            // {
            //     path: '/data_statistics/sql',
            //     component: () => import('../page/MysqlEditor.vue'),
            //     name: "MysqlEditorStat",
            //     meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_statistics },
            // }
            {
                path: '/data_statistics/sql',
                component: () => import('../page/MysqlEditorCopy.vue'),
                name: "MysqlEditorStat",
                meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_statistics },
            }
        ]
    },
    //数据加工-->任务管理
    // {path: '/data_manage', component: () => import('../page/DataManage.vue'), name: 'DataManage', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Data_Manage }},

    //数据加工-->加工任务管理
    { path: '/processing_task', component: () => import('../page/ProcessingTaskNew.vue'), name: 'ProcessingTask', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.Data_Manage } },
    //数据加工-->加工数据审计
    // { path: '/processing_data', component: () => import('../page/SemanticIncrement.vue'), name: 'SemanticIncrement', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.DATA_CALCULATE }},

    // 数据查看 - 数据全景
    { path: '/data_index', component: () => import('../page/view/DataIndex.vue'), name: 'DataIndex', meta: { header: HEADER_ACTIVE.INDEX, menu: MENU_ACTIVE.DATA_INDEX } },
    // 数据查看 - 数据资源
    { path: '/data_view_resource', component: () => import('../page/view/DataViewResource.vue'), name: 'DataViewResource', meta: { header: HEADER_ACTIVE.DATA_WORK, menu: MENU_ACTIVE.Data_View_Resource } },
    // 数据查看 - 数据资源详情
    { path: '/data_view_resource_info', component: () => import('../page/view/DataViewResourceInfo.vue'), name: 'DataViewResourceInfo', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.DATA_MODELING } },
    // 数据查看 - 数据模型
    // { path: '/data_view_model', component: () => import('../page/view/DataViewModel.vue'), name: 'DataViewModel', meta: { header: HEADER_ACTIVE.INDEX, menu: MENU_ACTIVE.Data_View_Model } },
    // 数据查看 - 数据算法
    { path: '/data_view_algorithm', component: () => import('../page/view/DataViewAlgorithm.vue'), name: 'DataViewAlgorithm', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.Data_View_Algorithm } },
    { path: '/data_view_algorithm_edit', component: () => import('../page/view/DataViewAlgorithmEdit.vue'), name: 'DataViewAlgorithmEdit', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.Data_View_Algorithm } },
    //个人工作台 - 我的数据资源
    { path: '/my_data_resource', component: () => import('../page/workbench/MyDataResource'), name: 'MyDataResource', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.My_Data_Resource } },
    //个人工作台 - 我的数据模型
    { path: '/my_data_model', component: () => import('../page/workbench/MyDataModel'), name: 'MyDataModel', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.My_Data_Model } },
    //个人工作台 - 我的智能计算
    { path: '/my_data_task', component: () => import('../page/workbench/MyDataTask'), name: 'MyDataTask', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.My_Data_Task } },
    //个人工作台 - 我的数据加工任务
    { path: '/my_process_task', component: () => import('../page/workbench/MyProcessTask'), name: 'MyProcessTask', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.MyProcessTask } },
    //个人工作台 - 我的数据算法
    { path: '/my_data_algorithm', component: () => import('../page/workbench/MyDataAlgorithm'), name: 'MyDataAlgorithm', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.My_Data_Algorithm } },
    //个人工作台 - 我的互动
    { path: '/my_interaction', component: () => import('../page/MyInteraction'), name: 'MyInteraction', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.My_interaction } },
    //个人工作台 - 我的组管理
    { path: '/my_grouping', component: () => import('../page/MyGrouping'), name: 'MyGrouping', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.My_grouping } },
    //综合管理 - 用户管理
    { path: '/user_power', component: () => import('../page/user/UserPower'), name: 'UserPower', meta: { header: HEADER_ACTIVE.USER_MANAGER, menu: MENU_ACTIVE.User_Power } },
    //综合管理 - 数据源管理
    { path: '/data_administrations', component: () => import('../page/DataAdministrations'), name: 'DataAdministrations', meta: { header: HEADER_ACTIVE.USER_MANAGER, menu: MENU_ACTIVE.Data_Administrations } },
    //综合管理 - 数据源管理-全部修改日志
    { path: '/data_administrations/ShowAllLog', component: () => import('../page/DataAdministrationsShowAllLog'), name: 'DataAdministrationsShowAllLog', meta: { header: HEADER_ACTIVE.USER_MANAGER, menu: MENU_ACTIVE.Data_Administrations } },
    //综合管理 -权限管理
    { path: '/permissionManagement', component: () => import('../page/PermissionManagement'), name: 'permissionManagement', meta: { header: HEADER_ACTIVE.USER_MANAGER, menu: MENU_ACTIVE.Permission_Management } },
    //综合管理 -安全审计
    { path: '/auditing', component: () => import('../page/Auditing'), name: 'Auditing', meta: { header: HEADER_ACTIVE.USER_MANAGER, menu: MENU_ACTIVE.User_Audit } },
     //综合管理 - 工作量统计
    { path: '/workloadStatistics', component: () => import('../page/WorkloadStatistics'), name: 'workloadStatistics', meta: { header: HEADER_ACTIVE.USER_MANAGER, menu: MENU_ACTIVE.User_Stat } },
    //综合管理 - 资产审核
    { path: '/AssetsAudit', component: () => import('../page/AssetsAudit'), name: 'AssetsAudit', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.Assets_Audit } },
    //下载管理-数据使用-数据内容发现
    { path: '/data_download1', component: () => import('../page/DataDownload.vue'), name: 'dataDownload', meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_content } },
    //下载管理-数据加工-数据编辑加工
    { path: '/data_download2', component: () => import('../page/DataDownload.vue'), name: 'dataDownload', meta: { header: HEADER_ACTIVE.DATA_USE, menu:  MENU_ACTIVE.DATA_MAINTAIN } },
    //下载管理-共享交换-信息资源导出
    { path: '/data_download3', component: () => import('../page/DataDownload.vue'), name: 'dataDownload', meta: { header: HEADER_ACTIVE.DATA_WORK, menu:  MENU_ACTIVE.Data_View_Resource } },
    //下载管理-共享交换-信息资源导出
    { path: '/data_download4', component: () => import('../page/DataDownload.vue'), name: 'dataDownload', meta: { header: HEADER_ACTIVE.DATA_MALL, menu:  MENU_ACTIVE.data_statistics } },
    // { path: '/data_download', component: () => import('../page/DataDownload.vue'), name: 'dataDownload', meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_content } },
    //数据加工-->数据获取
    // { path: '/data_get', component: () => import('../page/use/DataGet.vue'), name: 'DataGet', meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.DATA_GET } },
    {
        path: '/data_get',
        component: () => import('../page/use/DataGet.vue'),
        name: 'DataGet',
        meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_content },
        children: [
            {
                path: '/',
                component: () => import('../page/PaperList.vue'),
                name: "PaperList2",
                meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.data_content },
            }
        ]
    },
    {
        path: '/data_down',
        component: () => import('../page/use/DataDown'),
        name: 'DataDown',
        meta: { header: HEADER_ACTIVE.DATA_WORK, menu: MENU_ACTIVE.Data_View_Resource },
        children: [
            {
                path: '/',
                component: () => import('../page/PaperList.vue'),
                name: "PaperList3",
                meta: { header: HEADER_ACTIVE.DATA_WORK, menu: MENU_ACTIVE.Data_View_Resource },
            }
        ]
    },
    //数据加工-->在线分析
    // {
    //     path: '/online_analyse',
    //     component: () => import('../page/ProcessingData.vue'),
    //     name: 'OnlineAnalyse',
    //     meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.ONLINE_ANALYSE },
    //     children: [
    //         {
    //             path: 'python',
    //             component: () => import('../page/PythonEditor.vue'),
    //             name: "PythonEditor1",
    //             meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.ONLINE_ANALYSE },
    //         },
    //         {
    //             path: '/',
    //             component: () => import('../page/MysqlEditor.vue'),
    //             name: "MysqlEditor1",
    //             meta: { header: HEADER_ACTIVE.DATA_USE, menu: MENU_ACTIVE.ONLINE_ANALYSE },
    //         }
    //     ]
    // },
    //数据交换 - 数据登记列表
    { path: '/my_data_registration', component: () => import('../page/share/MyDataRegistration'), name: 'MyDataRegistration', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.DATA_Registration } },
    { path: '/data_registration', component: () => import('../page/share/DataRegistration'), name: 'DataRegistration', meta: { header: HEADER_ACTIVE.DATA_MALL, menu: MENU_ACTIVE.DATA_Registration } },
    { path: '/update_data_registration', component: () => import('../page/share/DataRegistration'), name: 'UpdateDataRegistration', meta: { header: HEADER_ACTIVE.MY_DATA, menu: MENU_ACTIVE.DATA_Registration } },
    { path: '/knowledge_tabs_list', component: () => import('../page/tabs/KnowledgeTabsList'), name: 'KnowledgeTabsList', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.ZHISHI_BIAOQIAN } },
    { path: '/knowledge_tabs', component: () => import('../page/tabs/KnowledgeTabsEdit'), name: 'KnowledgeTabs', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.ZHISHI_BIAOQIAN } },
    { path: '/knowledge_tabs_update', component: () => import('../page/tabs/KnowledgeTabsEdit'), name: 'KnowledgeTabsEdit', meta: { header: HEADER_ACTIVE.DATA_MANAGER, menu: MENU_ACTIVE.ZHISHI_BIAOQIAN } },
    { path: '/404', component: () => import('../page/view/404'), }, // 设置404页面的路由规则
    { path: '*', redirect: '/404' }, // 将所有未知路由重定向到404页面
]

Vue.use(Router)


const pushFunc = Router.prototype.push
Router.prototype.push = function push (location) {
    return pushFunc.call(this, location).catch(err => err)
}

export default new Router({
    routes,
    mode: 'history',
    strict: process.env.NODE_ENV !== 'production',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            if (from.meta.keepAlive) {
                from.meta.savedPosition = document.body.scrollTop
            }
            return { x: 0, y: to.meta.savedPosition || 0 }
        }
    }
})
